<template>
  <div class="header">
    <div class="icon-items">
      <div class="nav-item" v-for="(item, index) of navList" :key="index" @click="navClick(index)">
        <i :class="item.icon" style="margin: 0 3px; line-height: 28px"></i>
        <div v-if="PL && item.content == 'welcome'">
          <el-badge :value="PL">
            <span> {{ item.title }}</span>
          </el-badge>
        </div>
        <div v-else>
          <span> {{ item.title }}</span>
        </div>
      </div>

    </div>
    <slot name="nav"></slot>
    <div class="home-title-search">
      <el-input :placeholder="$t('message.placeholder.input')" class="input-with-select" @keyup.enter.native="getSearch"
        v-model="searchValue" size="small">
        <el-select :popper-append-to-body="true" popper-class="quickSearchSelect" v-model="selectValue" slot="prepend"
          :placeholder="$t('message.placeholder.select')">
          <el-option v-for="item in selectList" :label="item.label" :value="item.value" :key="item.index">
          </el-option>
        </el-select>

        <template slot="append">
          <div style="display: flex; gap: 12px">
            <div class="el-icon-search search-icon" @click="getSearch" :title="$t('message.title.quickSearch')"></div>
            <div class="boder-show"></div>
            <div class="iconfont icon-bianzu4 search-icon" @click="advancedSearch"
              :title="$t('message.title.advancedSearch')"></div>
          </div>
        </template>


      </el-input>
    </div>
    <div class="icon-list">
      <!-- <div>
        <i
          class="iconfont icon-bianzu4 search-icon"
          @click="advancedSearch"
          :title="$t('message.title.advancedSearch')"
        ></i>
      </div> -->
      <div>
        <el-dropdown :popper-append-to-body="true" popper-class="recentList">
          <span>
            <i class="el-icon-time search-icon" style="font-size: 24px"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item v-for="item in lastVisitList" :key="item.index">
                <div type="danger" @click="getItemLink(item)">
                  <span class="setting">
                    <i :class="item.icon"></i>
                    {{ item.name }}</span>
                </div>
              </el-dropdown-item> -->
            <draggable v-model="lastVisitList" group="menu" @start="onDragStart">

              <el-dropdown-item v-for="item in lastVisitList" :key="'' + item.id + item.type">
                <div type="danger" @click="getItemLink(item)" :title="getShowVal(item)">
                  <span class="setting">
                    <i :class="item.icon"></i>
                    {{ getShowVal(item) }}</span>
                </div>
              </el-dropdown-item>
            </draggable>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div>
        <el-dropdown class="recentList">
          <span>
            <i class="el-icon-collection-tag search-icon" style="font-size: 24px"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in favoriteList" :key="'' + item.id + item.type">
              <div type="danger" @click="getItemLink(item)" :title="getShowVal(item)">
                <span class="setting">

                  <i :class="item.icon"></i>
                  {{ getShowVal(item) }}</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div>
        <el-dropdown class="drop-down">
          <span><i class="iconfont icon-user user"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in dropdownList" :key="item.index">
              <div type="danger" @click="handleCommand(item)">
                <span class="setting"> <i :class="item.icon"></i> {{ item.title }}</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div>
        <el-dropdown :popper-append-to-body="true" popper-class="recentList">
          <span class="icon-wrapper">
            <i class="el-icon-message search-icon" style="font-size: 24px" @click="jumpToMyNotifications"></i>
            <!-- 红点元素 -->
            <!-- <span v-if="showBadge" class="notification-badge"></span> -->
          </span>
          <el-dropdown-menu slot="dropdown">
            <draggable v-model="unReadedDataList" group="menu" @start="onDragStart">
              <el-dropdown-item v-for="(item, index) in unReadedDataList" :key="'' + item.id + item.type">
                <div class="item-container">
                  <!-- 第一行：序号 + 内容 -->
                  <div class="main-line">
                    <span class="index-badge">{{ index + 1 }}.</span>
                    <span class="content-text">{{ item.name }}</span>
                  </div>
                  <!-- 第二行：时间 -->
                  <div class="time-line">
                    <span class="visit-time">{{ item.time }}</span>
                  </div>
                </div>
              </el-dropdown-item>
            </draggable>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { publicList } from "@/utils/publicstate";
import { mapState, mapMutations } from "vuex";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  data() {
    return {
      selectList: [],
      navList: [],

      baseNavList: publicList().navList,
      dropdownList: publicList().dropdownList,
      selectValue: "",
      searchValue: "",
      selectGroup: [],
      ProcessLength: 0,
      unReadedDataList: []
    };
  },
  computed: {
    ...mapState({
      lastVisitList: (state) => {
        const arr = state.menuList.find((i) => i.id == 104)?.children || [];
        // console.log(arr);
        const list = arr[1]?.children || [];
        return list;
      },
      favoriteList: (state) => {
        const arr = state.menuList.find((i) => i.id == 104)?.children || [];
        // console.log(arr);
        const list = arr[0]?.children || [];
        return list;
      },
      PL: (state) => state.ProcessLength,
    }),
  },
  watch: {
    lastVisitList(val) {
      console.log(val);

    }
  },
  created() {
    this.getInBoxInfo();
  },
  methods: {
    ...mapMutations(["setProcessLength"]),
    getShowVal(item) {
      const { name, description = "" } = item;
      const des = description === "" ? "" : " - " + description;
      return name + des;
    },
    navClick(i) {
      // this.browserShow = false;
      const item = this.navList[i];

      if (item.type === "folder") {
        item.path = "/folderList";
      }
      this.$router.push(item.path);
      this.newTab(item);
    },
    handleProjectCheck(val) {
      const item =
      {
        // icon: "iconfont icon-yibiao",
        // name: i18n.t("message.title.myDashboard"),
        title: '项目资源负载查看',
        name: 'project-load',
        path: "/projectload",
        content: "projectload",
        children: [],
        order: 1,
        query: { val }
      }
      // const path = '/projectload';
      // const query = { val }
      // this.$router.push({ path, query });
      this.newTab(item);
    },
    newTab(item) {
      console.log(item);
      // this.$store.commit("setPageRefresh");
      // this.$router.push(item.path);
      this.$router.push({ path: item.path, query: item.query });
      this.$store.dispatch('setTabItem', item)

    },
    getItemLink(item) {
      this.loadObject(item).then((res) => {
        const item = {
          ...res.object.objectID,
          name: res.object.objectName,
        };
        this.getLink(item);
        this.$store.commit("setPageRefresh");
      });
    },
    getProcess() {
      axios.get("/pmdm/changes/getChangeIdsByFlow?tableType=1").then((res) => {
        console.log(res);
        this.ProcessLength = res.data.object.size;
        // console.log(this.ProcessLength);
        this.setProcessLength(this.ProcessLength);
      });
    },

    async loadObject(e) {
      const objectInfo = {
        baseClassId: e.type,
        value: e.id,
      };
      let urlPre = e.type == 301 ? "/ppm/project/searchByObjId" : "/pmdm/search/byObjId";
      const { data } = await axios.get(`${urlPre + this.params(objectInfo)}`);
      return data;
    },

    getModules() {
      let arr = window.sessionStorage.getItem("modules").split(",").map(Number);

      this.baseNavList.map((i) => {
        if (arr.includes(i.order) || arr.includes(100)) {
          this.navList.push(i);
        }
      });
    },

    getSearchSelect() {
      axios.get("/pmdm/admin/cls/getBaseClses").then((res) => {
        const baselist = [{ name: this.$t('message.title.allFields'), id: 100 }, ...res.data.object.baseClses];
        this.selectList = baselist.map((i) => ({
          label: i.name,
          value: i.id,
        }));
        this.selectValue = this.selectList[0]?.value || "";
      });
    },

    advancedSearch() {
      let item = {
        title: this.$t("message.title.advancedSearch"),
        name: this.$t("message.title.advancedSearch"),
        path: "/advancedSearch",
        content: "/advancedSearch",
      };
      this.newTab(item);
      // this.routerReload();
    },

    getSearch() {
      // console.log(this.selectValue, this.searchValue);
      // this.editableTabsValue = '/welcome';
      const query = {
        id: this.selectValue,
        val: this.searchValue,
        page: 1,
        size: 1000
      };

      const path = "/simpleSearch";
      const item = {
        title: this.$t("message.title.search"),
        name: "simpleSearch",
        path,
        query,
      };
      this.$store.dispatch('setTabItem', item)
      this.$router.push({ path, query });
    },

    handleCommand(item) {
      console.log(item, item.link);
      if (item.link) {
        window.open(item.link);
      } else if (item.id == "b") {
        this.updatePsd();
      } else if (item.id == "c") {
        this.logout();
      } else {
        this.userSetting();
      }
    },

    logout() {
      this.$confirm(this.$t("message.confirm.logout"), this.$t("message.tips.tip"), {
        confirmButtonText: this.$t("message.button.affirm"),
        cancelButtonText: this.$t("message.button.cancel"),
        type: "warning",
      })
        .then(() => {
          axios.get("/pmdm/logout").then(this.clearData);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.cancel"),
          });
        });
    },

    clearData() {
      window.sessionStorage.clear();
      this.$store.commit("clearShowingTabsInHome");
      this.$router.push("/index");
      // //console.log('clear');
    },

    //个人设定
    userSetting() {
      var session = window.sessionStorage.getItem("userContext");
      session = JSON.parse(session);

      const { id, classId, subClassId } = session;
      const item = { id, classId, subClassId, title: session.loginId };
      this.getLink(item);
    },

    updatePsd() {
      let item = {
        title: this.$t("message.title.changePW"),
        name: this.$t("message.title.changePW"),
        path: "/upDatePsd",
        content: "/upDatePsd",
      };
      this.newTab(item);
    },
    onDragStart(event) {
      const menu = event.item["_underlying_vm_"];
      this.$store.commit("SET_DRAG_MENU", menu);
    },
    jumpToMyNotifications() {
      const item = {
        path: '/myNotifications',
        name: '我的通知',
        title: '我的通知'
      };
      this.$router.push(item.path);
      this.newTab(item);
    },
    async getInBoxInfo() {
      try {
        const session = JSON.parse(window.sessionStorage.getItem("userContext"));

        if (!session?.id) return;

        const { data: { object: { unreaded: unReadedData } = {} } = {} } =
          await axios.post("/pmdm/ObjectCommon/getInboxByUser", { userId: session.id });

        this.unReadedDataList = unReadedData?.map(({ id, subject, sentAt }) => ({
          id,
          name: subject,
          time: sentAt
        })) || [];
      } catch (error) {
        console.error("Failed to fetch inbox data:", error);
      }
    }
  },

  mounted() {
    this.getModules();
    this.getSearchSelect();
    this.getProcess();
  },
};
</script>

<style>
.home-title-search .el-select .el-input {
  width: 111px;
}

.quickSearchSelect .el-select-dropdown__wrap {
  max-height: 600px !important;
}

/* .recentList  */
.el-dropdown-menu {
  max-height: 600px !important;
  overflow-y: auto;
  overflow-x: hidden;
  /* padding: 5px 1px; */
}

.home-title-search .el-input-group__append {
  border-radius: 0 20px 20px 0;
  position: relative;
}

.home-title-search .el-input-group__prepend {
  border-radius: 20px 0 0 20px;
}

.home-title-search .el-input-group>.el-input__inner {
  background: #f5f7fa !important;
  border-right: 1px solid #f5f7fa;
  /* border-radius: 0 20px 20px 0; */
}

.home-title-search .el-input-group>.el-input__inner:focus {
  border: 1px solid #dcdfe6 !important;
  border-right: 1px solid #f5f7fa !important;
  background: #f5f7fa;
}
</style>

<style scoped>
.checkSource:hover {
  color: #fff;
}

.nav-item {
  padding: 8px 0;
  line-height: 28px;
  height: 28px;
  cursor: pointer;
  border-radius: 6px 6px 0 0;
  padding: 0 auto;
  display: flex;
  justify-content: center;
  color: black;
  font-size: 18px;
  flex: 1;
}

.nav-item:hover {
  /* background-image: url(../assets/navhover.png);
		background-size: 100% 100%; */
  color: #fff;
  cursor: pointer;
  /* chrome 10+, safari 5.1+ */
  background-image: -webkit-linear-gradient(0deg, #3ea4f9, #4588f9, #5c7c99);
  /* firefox; multiple color stops */
  background-image: -moz-linear-gradient(0deg, #3ea4f9, #4588f9, #5c7c99);
  /* ie10 */
  background-image: -ms-linear-gradient(0deg, #3ea4f9 0%, #4588f9 100%);
  /* opera 11.1 */
  background-image: -o-linear-gradient(0deg, #3ea4f9, #4588f9);
  /* 标准写法 */
  background-image: linear-gradient(0deg, #3ea4f9, #4588f9);
}

.header {
  height: 68px;
  background: #fff;
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.header .icon-items {
  /* margin: 22px 0 0 15px; */
  overflow: hidden;
  padding: 0 8px;
  display: flex;
  width: 60%;
  gap: 8px;
  justify-content: space-between;
}

.header .home-title-search {
  /* display: inline-block;
  margin-top: 30px;
  width: 98%; */
  width: 35%;
  margin: 0 1%;
}

.search-icon {
  /* font-size: 20px;
  color: #606266; */
  /* margin-top: 0px; */
  /* margin-left: 5px; */
  font-size: 14px;
  cursor: pointer;
}

.boder-show {
  border-left: #909399 1px solid;
  height: 14px;
}

.search-icon:hover {
  color: #3ea0fb;
}

.setting {
  margin-left: 5px;
  /* width: 500px; */
  display: block;
  max-width: 520px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 36px;
  height: 36px;
}

.setting-icon {
  font-size: 20px;
  color: #606266;
  display: inline-block;
  height: 68px;
  padding-top: 36px;
  /* line-height: 68px; */
}

.icon-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 35px;
  width: 8%;
  margin: 0 auto;
}

.advancedsearch {
  display: inline-block;
  /* border: #000 1px solid;
  border-radius: 16px; */
  cursor: pointer;
}

.drop-down {
  /* margin: 30px 0 0 36px; */
  position: relative;
  align-self: center;
}

.user {
  cursor: pointer;
  margin-top: 6px;
  font-size: 24px;
  font-weight: 400;
}

.user:hover {
  color: #3ea0fb;
}

.nav-icon {
  width: 36px;
  height: 36px;
  cursor: pointer;
  overflow: hidden;
}

.nav-icon:hover {
  background: #dae9fe;
}

.nav-icon .nav-img {
  width: 22px;
  height: 22px;
  margin-top: 20%;
  margin-left: 20%;
}

.active {
  /* background-image: url(../assets/navhover.png);
		background-size: 100% 100%;*/
  color: #fff;
  /* chrome 10+, safari 5.1+ */
  background-image: -webkit-linear-gradient(0deg, #3ea4f9, #4588f9, #5c7c99);
  /* firefox; multiple color stops */
  background-image: -moz-linear-gradient(0deg, #3ea4f9, #4588f9, #5c7c99);
  /* ie10 */
  background-image: -ms-linear-gradient(0deg, #3ea4f9 0%, #4588f9 100%);
  /* opera 11.1 */
  background-image: -o-linear-gradient(0deg, #3ea4f9, #4588f9);
  /* 标准写法 */
  background-image: linear-gradient(0deg, #3ea4f9, #4588f9);
}

.nav {
  font-size: 18px;
  color: #000;
  height: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
  display: flex;
  padding-right: 20px;
}

.nav li {
  width: 25%;
  float: left;
  align-self: center;
  text-align: center;
  height: 48px;
  line-height: 48px;
  padding: 0 15px;
  border-radius: 6px 6px 0 0;
  margin-left: 12px;
  overflow: hidden;
}

.nav li:hover {
  /* background-image: url(../assets/navhover.png);
		background-size: 100% 100%; */
  color: #fff;
  cursor: pointer;
  /* chrome 10+, safari 5.1+ */
  background-image: -webkit-linear-gradient(0deg, #3ea4f9, #4588f9, #5c7c99);
  /* firefox; multiple color stops */
  background-image: -moz-linear-gradient(0deg, #3ea4f9, #4588f9, #5c7c99);
  /* ie10 */
  background-image: -ms-linear-gradient(0deg, #3ea4f9 0%, #4588f9 100%);
  /* opera 11.1 */
  background-image: -o-linear-gradient(0deg, #3ea4f9, #4588f9);
  /* 标准写法 */
  background-image: linear-gradient(0deg, #3ea4f9, #4588f9);
}

.nav i {
  margin-right: 5px;
}

.item-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 520px;
  min-height: 36px;
  padding: 4px 12px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f7fa;
  }
}

.main-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-grow: 1;
  min-width: 0;

}

.index-badge {
  flex-shrink: 0;
  color: #909399;
  margin-left: 5px;
  line-height: 20px;
}

.content-text {
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
  font-size: 12px;
  color: #606266;
}

.time-line {
  flex-shrink: 0;
  margin-left: 23px;
  line-height: 16px;
}

.visit-time {
  color: #c0c4cc;
  font-size: 12px;
  display: block;
  white-space: nowrap;
}

.icon-wrapper {
  position: relative;
  display: inline-block;
  line-height: 1;
}

/* .notification-badge {
  position: absolute;
  right: -2px;
  width: 10px;
  height: 10px;
  background-color: #f56c6c;
  border-radius: 50%;
  border: 1px solid white;
  box-sizing: border-box;
  animation: pulse 1.5s infinite;
} */
</style>
